import React, {useState} from 'react'

import Loading from '../../component/Loading/Loading'
import ReadpointSelector from '../../readpoint/component/ReadpointSelector'
import AssetSelector from '../../component/Asset/AssetSelector'
import HttpRequest from '../../services/HttpRequest'
import NodeSelector from "../../gateways/component/NodeSelector";
import ReadpointMomentReadSelector from "../../readpoint/component/ReadpointMomentReadSelector";
import {InputWithLabel} from "../../component/Form/InputWithLabel";
import Page from "../../component/Page/Page";

const request = new HttpRequest()

export const DevNewCloudSense = () => {

  const [node, setNode] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const doRequest = async () => {
    const data = {
      "type": this.type,
      "nodeMac": node.uuid,
      "antenna": this.antenna,
      "when": new Date(),
      "epc": this.epc
    }
    await request.post('/cloud/v1/create-new-event', data)
    setIsLoading(false)
  }

  return (
      <Page title="DEV MODE - Cloud Sensing">

        <NodeSelector onChange={a => setNode(a)}/>
        <InputWithLabel
            label="Antena"
            placeholder="TAG_STOP_READ ou TAG_START_READ"
            required
            onChangeText={text => this.type = text}
            defaultValue={"TAG_START_READ"}
        />

        <InputWithLabel
            label="Antena"
            placeholder="Antena (0,1,2,3)"
            required
            onChangeText={text => this.antenna = text}
            defaultValue={"0"}
        />

        <InputWithLabel
            label="Digite o EPC"
            placeholder="Digite o EPC"
            required
            onChangeText={text => this.epc = text}
        />

        <button onClick={doRequest}>enviar</button>
        {isLoading ? <Loading/> : 'Preparado para enviar request'}

      </Page>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Dev/DevNewCloudSense.js